import DownloadIcon from '@mui/icons-material/Download';
import { Box } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getStripeRechargeInvoices } from 'wisestep-api';
import { WsColors, WsIconText } from 'wisestep-base';

const RechargeInvoices = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState<Record<string, unknown>[]>([]);
  const [total, setTotal] = useState<number>(0);
  const columns: GridColDef[] = [
    {
      field: 'id',
      headerName: 'S no.',
      width: 20,
    },
    {
      field: 'description',
      headerName: 'Description',
      width: 250,
    },
    {
      field: 'amount',
      headerName: 'Amount',
      width: 150,
    },
    {
      field: 'credit',
      headerName: 'Credit',
      width: 150,
    },
    {
      field: 'createdOn',
      headerName: 'Created On',
      width: 150,
    },
    {
      field: 'invoiceURL',
      headerName: 'Actions',
      renderCell: (params) => (
        <WsIconText
          text=""
          textCursor="pointer"
          onClick={() => navigate(`/app-settings/recharge/my-invoices/${params.row.invoiceNumber}`)}
          icon={<DownloadIcon sx={{ color: WsColors.TheBlues500 }} />}
        />
      ),
    },
  ];

  useEffect(() => {
    (async () => {
      const res = await getStripeRechargeInvoices({
        page: 0,
        size: 10,
      });
      if (res?.data?.content && res.data.content.length > 0) {
        setTotal(res.data.totalElements);
        const tempRows: Record<string, unknown>[] = [];
        res.data.content.map((invoice, index) => {
          tempRows.push({
            id: index,
            createdOn: dayjs(invoice.createdOn).format('DD MMM YYYY HH:mm'),
            description: `Recharged SMS Credits`,
            amount: `$ ${invoice.amount}`,
            credit: invoice.credited,
            invoiceNumber: invoice.id,
            invoiceURL: '',
          });
        });
        setRows(tempRows);
      }
    })();
  }, []);

  const onPagination = async (page: number) => {
    const res = await getStripeRechargeInvoices({
      page: page,
      size: 10,
    });
    if (res?.data?.content && res.data.content.length > 0) {
      setTotal(res.data.totalElements);
      const tempRows: Record<string, unknown>[] = [];
      res.data.content.map((invoice, index) => {
        tempRows.push({
          id: index,
          createdOn: dayjs(invoice.createdOn).format('DD MMM YYYY HH:mm'),
          description: `SMS Credits Recharged`,
          amount: `$ ${invoice.amount}`,
          credit: invoice.credited,
          invoiceNumber: invoice.id,
          invoiceURL: '',
        });
      });
      setRows(tempRows);
    }
  };

  return (
    <Box sx={{ height: '670px', mt: 2 }}>
      <DataGrid
        rows={rows}
        columns={columns}
        rowCount={total}
        onPageChange={onPagination}
        paginationMode="server"
        pageSize={10}
      />
    </Box>
  );
};

export default RechargeInvoices;
